import { runtimeConfig } from "@/shared/config/runtime";

const BASE = runtimeConfig.rocketchatUrl.replace(/\/$/, "");
export const ROCKETCHAT_BASE_URL = `${BASE}/group`;
export const ROCKETCHAT_ADMIN_URL = `${BASE}/home`;
